module.exports = __webpack_public_path__ + "static/media/daniel.935fd5f9.jpg";